import { msg } from '@lingui/core/macro';

import { defineFilters } from '@/shared/filters/define-filters';
import { documentInputRaw, maskDocumentInput } from '@/shared/format/document';

import { ACCOUNT_TYPE_FILTER, BANK_ACCOUNT_REQUEST_STATUS } from './bank-account-request.status';

// Filtros da lista declarados uma vez (P01): `availableFilters` do `FilterProvider`
// (BankAccountRequestListContainer.tsx:195-222) e o formulário (BankAccountRequestFilters.tsx:28-218).
// Arquivo leve: a rota usa o `shape` no `validateSearch`.

const PHONE_MASK = '(00) 00000-0000';

/**
 * `phoneNumberMask` (utils/constants/masks/phoneNumberMask.ts) no `MaskedInput` do filtro: o fio leva o
 * telefone mascarado, como o `react-text-mask` grava (U21).
 */
export function maskPhoneFilter(value: string): string {
  const digits = value.replace(/\D/g, '').slice(0, 11);
  let out = '';
  let index = 0;
  for (const slot of PHONE_MASK) {
    if (index >= digits.length) break;
    if (slot === '0') {
      out += digits.charAt(index);
      index += 1;
    } else {
      out += slot;
    }
  }
  return out;
}

/**
 * CPF/CNPJ com a máscara progressiva do filtro (`getDocumentMask(isLegalPerson)`, BankAccountRequestFilters.tsx:22-23
 * e :65-83): o fio leva o documento mascarado, **com as letras** do CNPJ alfanumérico.
 */
export const maskDocumentFilter = (raw: string) => maskDocumentInput(documentInputRaw(raw));

/** Na ordem do "Filtrar" do legado (BankAccountRequestFilters.tsx:33-44). */
export const bankAccountRequestFilters = defineFilters([
  { key: 'searchString', type: 'search', label: msg`Todos`, placeholder: msg`Procurar` },
  { key: 'registrationNumber', type: 'document', label: msg`CPF/CNPJ`, toParam: maskDocumentFilter },
  { key: 'email', type: 'text', label: msg`Email` },
  { key: 'partnerName', type: 'text', label: msg`Nome do parceiro` },
  { key: 'ownerDisplay', type: 'text', label: msg`Nome do solicitante` },
  { key: 'accountNumber', type: 'text', label: msg`Número da conta` },
  { key: 'phone', type: 'text', label: msg`Número de telefone`, toParam: maskPhoneFilter },
  { key: 'status', type: 'status', label: msg`Status`, options: BANK_ACCOUNT_REQUEST_STATUS, pinned: true },
  { key: 'typeAccount', type: 'select', label: msg`Tipo de conta`, options: ACCOUNT_TYPE_FILTER },
  { key: 'initialDate', to: 'finalDate', type: 'dateRange', label: msg`Data de início`, fromLabel: msg`Filtrar por data de início`, toLabel: msg`Filtrar por data final` },
]);
